import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { HomePage } from './pages/HomePage';
import { ProblemListPage } from './pages/ProblemListPage';
import { ProblemDetailPage } from './pages/ProblemDetailPage';
import { SubmissionDetailPage } from './pages/SubmissionDetailPage';
import { SubmissionListPage } from './pages/SubmissionListPage';
import { ProfilePage } from './pages/ProfilePage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { Footer } from './components/Footer';
import { CURRENT_USER_QUERY_KEY, useCurrentUser } from './hooks/useCurrentUser';
import { api } from './lib/api';

export function App() {
  return (
    <div className="app">
      <Header />
      <main className="app-main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/problems" element={<ProblemListPage />} />
          <Route path="/problems/:slug" element={<ProblemDetailPage />} />
          <Route path="/submissions" element={<SubmissionListPage />} />
          <Route path="/submissions/:id" element={<SubmissionDetailPage />} />
          <Route path="/u/:username" element={<ProfilePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function Header() {
  const { user, isLoading } = useCurrentUser();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  async function handleLogout() {
    try {
      await api.logout();
    } catch {
      // If logout fails (e.g. network) we still want the UI to reflect anon state.
    }
    queryClient.setQueryData(CURRENT_USER_QUERY_KEY, { user: null });
    navigate('/');
  }

  return (
    <header className="app-header">
      <Link to="/" className="brand">
        FlareCode
      </Link>
      <nav>
        <Link to="/problems">Problems</Link>
        {isLoading ? null : user ? (
          <>
            <Link to="/submissions">My submissions</Link>
            <Link to={`/u/${user.username}`}>@{user.username}</Link>
            <button type="button" className="linklike" onClick={handleLogout}>
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/login">Sign in</Link>
            <Link to="/register">Register</Link>
          </>
        )}
      </nav>
    </header>
  );
}
